import { Dialog, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from "types/ClassName";
import { DetailsItem } from 'components';
import SingleFieldForm from 'containers/settings/company-profile/forms/SingleFieldForm/SingleFieldForm';
import { useToastDispatch } from 'contexts/ToastContext';
import { useOpenable, usePositionUpdate } from 'hooks';
import IPosition from 'types/Position';
import { t } from 'utils/localize';
import { v_require } from 'utils/validations';

export interface IPositionTitleDetailsProps {
  className?: ClassName;
  position: IPosition;
  onUpdate: () => Promise<any>;
  editable: boolean;
}

const PositionTitleDetails = (props: IPositionTitleDetailsProps) => {
  const { className, position, onUpdate, editable } = props;
  const [updateKey] = usePositionUpdate();
  const toastDispatch = useToastDispatch();

  const classes = classNames('position-title-details', className);
  const editTitleDialog = useOpenable();
  const validations = [
    {
      validation: v_require,
    },
  ];

  async function handleSubmit(newTitle: IPosition['title']) {
    if (position.title !== newTitle) {
      try {
        await updateKey(position.id, 'title', newTitle);
      } catch (e) {
        toastDispatch({
          type: 'OPEN',
          payload: { theme: Theme.DANGER, label: t('Unable to update title. Please try again later.') },
        });
      }

      onUpdate();
    }

    editTitleDialog.close();
  }

  return (
    <>
      <DetailsItem
        title={t('Title')}
        disabled={!editable}
        onClick={editTitleDialog.open}
        value={position.title}
        className={classes}
      />
      <Dialog position={'center'} isOpen={editTitleDialog.isOpen} onClose={editTitleDialog.close}>
        <SingleFieldForm
          title={t('Title')}
          subtitle={t('Required')}
          initialValue={position.title}
          onSubmit={handleSubmit}
          className="mt-4 p-8"
          validations={validations}
        />
      </Dialog>
    </>
  );
};

export default PositionTitleDetails;
